import React from 'react';
import ReactDOM from 'react-dom';
import PwsPopupGlobalModal from '../components/PwsPopupGlobalModal';
import getCurrentPopup from './getCurrentPopup';

export default function register() {
    window.addEventListener('DOMContentLoaded', render);
}

const STORAGE_KEY = 'pwsHomePagePopupsClosed';

function render() {
    const currentPopup = getCurrentPopup();
    if (!currentPopup) {
        return;
    }

    const popupsClosed = JSON.parse(
        window.localStorage.getItem(STORAGE_KEY) || '[]'
    ) as string[];
    if (popupsClosed.includes(currentPopup.popupId)) {
        return;
    }

    const handleClose = () => {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify([
            ...popupsClosed,
            currentPopup.popupId,
        ]));
    };

    const el = document.createElement('div');
    document.getElementsByTagName('body')[0].appendChild(el);
    ReactDOM.render(<PwsPopupGlobalModal
        popup={currentPopup}
        onClose={handleClose}
    />, el);
}
